import {IFieldValidator} from "../field-validator.interface";
import {NullableString, NullableUndefinedString} from "../../../types/nullable-types";
import {IServiceFactory} from "../../../services/service-factory.interface";
import {Check} from "../../../types/type-checking";

export function isAmexCard(cardNumber: NullableUndefinedString): boolean {
    if(!cardNumber) {
        return false;
    }

    if (cardNumber.length !== 15) {
        return false;
    }


    const prefix = cardNumber.substring(0, 2);
    return prefix === '34' || prefix === '37';

}

export class DenyAmexValidator implements  IFieldValidator {
    constructor(private readonly services: IServiceFactory) {
    }

    validate(fieldValue: any): NullableString {
        if(!fieldValue) {
            return null;
        }

        if(isAmexCard(fieldValue)) {
            return this.services.language.translate('American Express cards are not supported');
        }

        return null;
    }


}

export class CardNumberValidator implements  IFieldValidator {
    constructor(private readonly services: IServiceFactory) {
    }

    validate(fieldValue: any): NullableString {
        if(!fieldValue) {
            return null;
        }

        if(!Check.isString(fieldValue)) {
            return this.services.language.translate('Is not a valid card number');
        }

        if(!this.services.configuration.data.payments.validateCreditCardNumber) {
            return null;
        }

        const testCards = this.services.configuration.data.payments.testCards ?? [];

        fieldValue = fieldValue.trim();

        if(testCards.includes(fieldValue)) {
            return null;
        }

        if(this._isValidCardNumber(fieldValue)) {
            return null;
        }

        return this.services.language.translate('Is not a valid card number');
    }


    private _isValidCardNumber(cardNumber: string): boolean {

        if (cardNumber.length < 12 || cardNumber.length > 19) {
            return false; // Card numbers are typically between 12 and 19 digits
        }

        //Luhn Algorithm.
        let sum = 0;
        let shouldDouble = false;

        // Process the card number from right to left (reverse order)
        for (let i = cardNumber.length - 1; i >= 0; i--) {
            let digit = parseInt(cardNumber[i]);
            if(!Check.isNumber(digit)) {
                return false;
            }
            if (shouldDouble) {
                digit *= 2;
                if (digit > 9) {
                    digit -= 9; // For numbers > 9, sum the individual digits
                }
            }

            sum += digit;
            shouldDouble = !shouldDouble; // Alternate between doubling and not doubling
        }

        // A valid card number will have a sum divisible by 10
        return sum % 10 === 0;

    }

}
